import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const introduce = async (params: object) => {
  return await GET({ url: Api.introduce, params, showError: false })
}
